import { Button, Result } from "antd";
import { Link } from "react-router-dom";

/** 404 page for unknown routes — mirrors the 403 page rather than silently
 *  bouncing to the dashboard (a mistyped/stale link should say so). */
function NotFound() {
  return (
    <Result
      status="404"
      title="404"
      subTitle="This page doesn't exist — the link may be outdated or mistyped."
      extra={
        <Link to="/">
          <Button type="primary">Back to dashboard</Button>
        </Link>
      }
    />
  );
}

export default NotFound;
